module.exports = __webpack_public_path__ + "images/4ba53dbea6343b3d9ad4cbb076784c58900083362f2656b24545ba41cfe7cf0a.svg";